module.exports = __webpack_public_path__ + "static/media/sign_up_4.7ed89887.png";